import React from 'react';
import { Link } from 'react-router-dom';
import './Card.css';

interface CardProps {
  title: string;
  description: string;
  image: string;
  linkTo: string;
  className?: string;
}

const Card: React.FC<CardProps> = ({ title, description, image, linkTo, className }) => {
  return (
    <Link to={linkTo} className={`card ${className || ''}`}>
      <div className="card-image-container">
        <img src={image} alt={title} className="card-image" />
      </div>
      <div className="card-content">
        <h3 className="card-title">{title}</h3>
        <p className="card-description">{description}</p>
        <div className="card-footer-line"></div>
      </div>
    </Link>
  );
};

export default Card;
